import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3b86adc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-tab is-sticky" }
const _hoisted_2 = { class: "resume_contents_wrapper" }
const _hoisted_3 = { class: "resume_sticky_button" }
const _hoisted_4 = { class: "resume_sticky_button_inner" }

import Desired from '@/components/Desired.vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import TabBar from '@/components/TabBar.vue';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'DesiredView',
  setup(__props) {

const router = useRouter();
const isLoading = ref(false);

const init = async () => {
  isLoading.value = true;
  try {
    await Promise.all([
      store.dispatch('careerSheetDesired/getDesiredCondition'),
      store.dispatch('master/getMasterDataListIndsctg'),
      store.dispatch('master/getMasterDataOcupClass'),
      store.dispatch('master/getMasterDataListEmpTypeBusicr'),
      store.dispatch('master/getMasterDataListPref'),
      store.dispatch('master/getMasterWishJobChangeDateId'),
      store.dispatch('userMenu/receive'),
    ]);
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

// 学歴スキル_閲覧画面
const transitionViewEducationSkillPage = () => {
  router.push({ name: 'e50', query: { ref: 'e' } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(TabBar),
            _createVNode(Desired)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(BaseButton, {
                theme: "primary",
                onClick: transitionViewEducationSkillPage
              }, {
                default: _withCtx(() => [
                  _createTextVNode("学歴・スキルの確認をする")
                ]),
                _: 1
              })
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})